import React, { Fragment } from 'react'
import {
  Box,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'
import { Link } from 'react-router-dom';
import { MdOutlineChevronRight } from "react-icons/md";
import AllFillters from './Layout/AllFillters';

const AllDispute = ({ title, head, data }) => {
  
  return (
    <Fragment>
    <AllFillters
             title={title}
             data={data}
             // filters = {[{"Order Date":filterbyOrderDate}, {"Delivery Date":filterbyDeliveryDate}, {"Electronics":filterbyCategory}]}
            //  filters = {[{"Date": filterbyDate}, {"Profession": filterByProfession}]}
          />
   <Box maxW={'full'} my={4}>
             <TableContainer>
                 <Table variant={'simple'} size={'xs'}>
                     <Thead bgColor={'gray.100'}>
                         <Tr bgColor={'#E2DFDF'}>
                             {head.map((h, i) => (
                                 <Th fontSize={'xs'} py={3} key={i} _first={{paddingLeft: '20px'}} color={'#25282B'}>{h}</Th>
                             ))}
                         </Tr>
                     </Thead>
                     <Tbody>
                         {data.map((d, i) => (
                             <Tr key={i} bgColor={'white'}>
                                 <Td fontSize={'xs'} py={3} pl={5}>{d.dispute_id}</Td>
                                 <Td fontSize={'xs'} py={3}>{d.email_id}</Td>
                                 <Td fontSize={'xs'} py={3}>{d.dispute_type}</Td>
                                 <Td fontSize={'xs'} py={3}>{d.dispute_status}</Td>
                                 <Td fontSize={'xs'}>
                                     <Flex>
                                         <Box bgColor={'gray.200'} rounded={'full'} my="auto" p={2} mx={2}>
                                             <Link to={`/dispute/details/123456`} > <MdOutlineChevronRight /> </Link>
                                         </Box>
                                     </Flex>
                                 </Td>
                             </Tr>
                         ))}

                     </Tbody>
                 </Table>
             </TableContainer>
         </Box>
 </Fragment>
  )
}

export default AllDispute